// Copyright (c) 2018 Deere & Company

import actions from '../actions-list';

export const resetRequestDetails = () => ({
    type: actions.RESET_REQUEST_DETAILS
});

export const setFormToPrestine = () => ({
    type: actions.RESET_FORM_IS_DIRTY_TO_FALSE
});



// WEBPACK FOOTER //
// ./src/part-requests/request-details/action-creators/reset-request-details.js